import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import { Table } from 'rsuite'
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { translate } from 'react-i18next';
import './workPlanListTable.scss';
const { Column, HeaderCell, Cell } = Table;
const WorkPlanListTable = ({
    sortValues,
    setSortValues,
    height,
    filteredWorkPlans,
    handleNameClick,
    chipStatus,
    genOrgPathField,
    buttonsHandler,
    openDeleteDialog,
    t,
    ...props
}) => (
    <Table
        sortColumn={sortValues.sortColumn}
        sortType={sortValues.sortType}
        onSortColumn={(sortColumn, sortType) => setSortValues({ sortColumn, sortType })}
        height={height}
        data={filteredWorkPlans}
        id="wp-workPlans"
        className="workPlanList-table"
        rowKey={"workplanId"}
        rowClassName="workPlanList-table-row"
        shouldUpdateScroll={false}
        renderEmpty={(info) => {
            return <>
                <div className={"rs-table-body-info"}>
                    Empty list
                </div></>;

        }}
    >
        <Column
            flexGrow={4}
            sortable
            key="name"
        >
            <HeaderCell>{t("workPlanList.columns.name")}</HeaderCell>
            <Cell dataKey="name">
                {(rowData) => (
                    <div className='workPlanList-table-name-cell' onClick={() => handleNameClick(rowData)}>
                        <div>{chipStatus(rowData.currentStatus.value)}</div>
                        <CustomToolTip
                            enterDelay={250}
                            titletext={rowData.name}
                            jsx={<div>{rowData.name}</div>}
                        />
                    </div>)}
            </Cell>
        </Column>
        <Column
            flexGrow={4}
            sortable
            key="description"
        >
            <HeaderCell>{t("workPlanList.columns.description")}</HeaderCell>
            <Cell dataKey="description">{(rowData) =>
                <CustomToolTip
                    enterDelay={250}
                    titletext={rowData.description}
                    jsx={<div>{rowData.description}</div>}
                />}
            </Cell>
        </Column>
        <Column
            flexGrow={3}
            minWidth={275}
            key="jobs"
        >
            <HeaderCell className="wpl-job-header-cell">{t("workPlanList.columns.job")}</HeaderCell>
            <Cell dataKey="jobs" className="wpl-job-cell">{(rowData) =>
                <div>{genOrgPathField(rowData.jobs, document.querySelector('.wpl-job-cell'))}</div>}
            </Cell>
        </Column>
        <Column
            flexGrow={1}
            sortable
            key="duration"
            minWidth={125}
        >
            <HeaderCell>{t("workPlanList.columns.duration")}</HeaderCell>
            <Cell dataKey="duration">{(rowData) => {
                const duration = rowData.periodLength + ' '
                + (rowData.periodType === 'Weeks' 
                    && rowData.periodLength === 1 
                    ? 'Week' 
                    : rowData.periodType === 'Days' 
                        && rowData.periodLength === 1 
                        ? 'Day' 
                        : rowData.periodType);
                    return (<CustomToolTip
                        enterDelay={250}
                        titletext={duration}
                        jsx={<div>{duration}</div>}
                    />);
                    }
            }</Cell>
        </Column>
        <Column
            flexGrow={2}
            sortable
            key="effectiveDate"
        >
            <HeaderCell>{t("workPlanList.columns.startDate")}</HeaderCell>
            <Cell dataKey="effectiveDate">{(rowData) =>
                <CustomToolTip
                    enterDelay={250}
                    titletext={rowData.displayEffectiveDate}
                    jsx={<div>{rowData.displayEffectiveDate}</div>}
                />
            }</Cell>
        </Column>
        <Column
            flexGrow={2}
            sortable
            key="endDate"
        >
            <HeaderCell>{t("workPlanList.columns.endDate")}</HeaderCell>
            <Cell dataKey="endDate">{(rowData) =>
                <CustomToolTip
                    enterDelay={250}
                    titletext={rowData.displayEndDate}
                    jsx={<div>{rowData.displayEndDate}</div>}
                />
            }</Cell>
        </Column>
        <Column
            flexGrow={3}
            minWidth={200}
        >
            <HeaderCell></HeaderCell>
            <Cell>
                {(rowData) => (
                    <div className='workPlanList-table-action-button-container'>
                        <CustomToolTip enterDelay={250} titletext={t('workPlanList.actions.edit')} jsx={
                            <div className="item">
                                <Button disabled={rowData.isLocked} onClick={(e) => { buttonsHandler(e, 'EditWorkplan', rowData) }}  >
                                    <FontAwesomeIcon icon={['fas', 'edit']} color={rowData.isLocked ? '#E1E1E1' : "#0A54A2"} size="1x" />
                                </Button>
                            </div>
                        } />
                        <CustomToolTip enterDelay={250} titletext={t('workPlanList.actions.duplicate')} jsx={
                            <div className="item">
                                <Button onClick={(e) => { buttonsHandler(e, 'DuplicateWorkplan', rowData) }}>
                                    <FontAwesomeIcon icon={['fas', 'clone']} color="#0A54A2" size="1x" />
                                </Button>
                            </div>
                        } />
                        <CustomToolTip enterDelay={250} titletext={t('workPlanList.actions.delete')} jsx={
                            <div className="item">
                                <Button disabled={(rowData.states !== null && rowData.states.length > 0) || rowData.isLocked} onClick={(e) => {
                                    e.stopPropagation();
                                    openDeleteDialog(rowData.workplanId, rowData.name);
                                }}>
                                    <FontAwesomeIcon icon={['fas', 'trash']} color={(rowData.states && rowData.states.length > 0) || rowData.isLocked ? '#E1E1E1' : "#0A54A2"} size="1x" />
                                </Button>
                            </div>
                        } />
                    </div>
                )}
            </Cell>
        </Column>
    </Table>
);
export default translate('workplanManager')(WorkPlanListTable);
